import { computed } from 'vue'
import { useFeatureStore } from '$/stores/feature.ts'

export function useCostCalculate() {
  const featureStore = useFeatureStore()

  const totalCost = computed(() => {
    let result = 0
    const costs = featureStore.featureLimits.filter((i) => i.feature_slug === featureStore.feature.slug)

    // Full size
    if (featureStore.taskOptions.size === 'full') {
      featureStore.imageData.forEach((datum) => {
        // Only cost credit when image width or height is greater than the min feature limit
        if (datum.width > costs[0].max_width || datum.height > costs[0].max_height) {
          result += 1
        }
      })
    }

    if (featureStore.feature.slug === 'face-swap') {
      if (featureStore.options['face-swap'].nsfw) {
        result += featureStore.images.length
      }
    } else if (featureStore.feature.slug === 'upscale-and-enhance-image') {
      if (featureStore.options['upscale-and-enhance-image'].upscale === 4) {
        result += featureStore.images.length
      }
    } else if (featureStore.feature.slug === 'remove-background') {
      if (featureStore.options['remove-background'].mode === 'quality') {
        result += featureStore.images.length
      }
    }

    return result
  })

  return {
    totalCost,
  }
}
